import {
    useEffect,
    useState
} from 'react';
import { useSelector } from 'react-redux';

import { getUserInfo } from '../selectors';

export const useUserInfo = () => {
    const [ info,
        setInfo ] = useState({});
    const user = useSelector(getUserInfo);

    useEffect(() => {
        setInfo(user ?? {});
    }, [ user ]);

    return info;
};
